import PickupAndDeliveryZone from 'components/Catalog/ProductGrid/CompareModal/Zones/PickupAndDeliveryZone/PickupAndDeliveryZone';

export default PickupAndDeliveryZone;
